import { queryOptions } from '@tanstack/react-query'
import { ApiError, authRequest, rememberSessionContour } from '@/shared/api'
import { MeSchema, type Session, sessionFromMe } from '../model/types'

export const sessionKeys = {
  me: ['session', 'me'] as const,
}

// 401 у /auth/me = «не залогинен» → session null (не ошибка): root beforeLoad
// уведёт на страницу входа хаба. Прочие ошибки пробрасываем.
export const sessionQueryOptions = queryOptions({
  queryKey: sessionKeys.me,
  queryFn: async (): Promise<Session | null> => {
    try {
      const body = await authRequest<{ data: unknown }>({ method: 'GET', url: '/me' })
      const session = sessionFromMe(MeSchema.parse(body.data))
      // Единственное место, где контур сессии виден фронту: дальше по нему
      // выбирается ручка продления на 401 (00-architecture § 3).
      rememberSessionContour(session.kind)
      return session
    } catch (error) {
      if (error instanceof ApiError && error.isUnauthorized) return null
      throw error
    }
  },
  staleTime: 60_000,
})
